import { createSelector } from "reselect";

export const cartItems = (state) => state.cart.relationships.filter((item) => item.type === "orderItem");

export const selectOrderItems = createSelector(cartItems, (cartItems) => cartItems);

export const selectOrderItemProducts = createSelector(cartItems, (cartItems) =>
  cartItems.all.relationships ? cartItems.all.relationships.filter((rel) => rel && rel.type === "product") : []
);
